import { createUseStyles } from '@glu/theming';
import React from 'react';
import styles from './Tooltip.styles';
import Position from './Position';
import { PanelOption } from './Dropdown';

const useStyles = createUseStyles(styles);

interface Props {
  /** Function to format the appearance of the label printed in the tooltip */
  format(option: PanelOption): string;
  /** Selection made by user  */
  selection: PanelOption[];
}

const Tooltip = ({ format, selection }: Props) => {
  const classes = useStyles();

  return (
    <Position className={classes.tooltip} dataQa="tooltip-position" scroll>
      <div className={classes.contentWrapper}>
        {selection.map((option) => (
          <p key={option.name}>
            {option.path &&
              option.path.map((step, idx) => idx < option.path.length && `${step.name} > `)}
            {format(option)}
          </p>
        ))}
      </div>
    </Position>
  );
};

export default Tooltip;
